import { neutral } from '../global';
export const brandAltText = {
    primary: neutral[7],
    supporting: neutral[60],
    ctaPrimary: neutral[100],
    ctaSecondary: neutral[7],
    ctaTertiary: neutral[7],
    anchorPrimary: neutral[7],
};
//# sourceMappingURL=brand-alt.js.map
